import React, { useMemo } from 'react';
import '../styles/christmas.css';

/**
 * SnowflakesEffect component - renders animated snowflakes, Christmas trees, and Santas
 */
const SnowflakesEffect: React.FC = () => {
  // Generate random falling Christmas elements - memoized to prevent regeneration on re-render
  const fallingElements = useMemo(() => {
    return Array.from({ length: 30 }, (_, i) => {
      // Randomly pick an icon (more snowflakes than trees/santas)
      const randomIndex = Math.random();
      let icon;
      if (randomIndex < 0.6) {
        icon = '❅'; // 60% snowflakes
      } else if (randomIndex < 0.8) {
        icon = '🎄'; // 20% Christmas trees
      } else {
        icon = '🎅'; // 20% Santas
      }
      
      return {
        id: i,
        icon,
        left: `${Math.random() * 100}%`,
        animationDuration: `${8 + Math.random() * 8}s`,
        animationDelay: `${Math.random() * 5}s`,
      };
    });
  }, []); // Empty dependency array means this only runs once

  return (
    <div className="christmas-snowflakes">
      {fallingElements.map((element) => (
        <div
          key={element.id}
          className="snowflake"
          style={{
            left: element.left,
            animationDuration: element.animationDuration,
            animationDelay: element.animationDelay,
          }}
        >
          {element.icon}
        </div>
      ))}
    </div>
  );
};

export default SnowflakesEffect;
